<!-- TEMPLATE -->
<template>
  <svg
    :class="className"
    :viewBox="glyph.viewBox"
    preserveAspectRatio="xMinYMid"
  >
    <use :xlink:href="'#' + glyph.id" :href="'#' + glyph.id" :x="x" :y="y" />
  </svg>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// COMPONENTS
@Component({})
export default class deanIcon extends Vue {
  // PROPS
  @Prop() className!: string;
  @Prop() glyph!: object;
  @Prop() x!: string;
  @Prop() y!: string;
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

svg {
  user-select: none;
}
</style>
